import React, {useState} from 'react';
import * as S from './MypHeaderContainer.styles';

const MypHeaderContainer = ({
  isSticky,
  subText,
  imgTxt,
  imgSubTxt,
  heading,
  image,
  header = {},
  subHeadingImage,
}) => {
  return (
    <S.HdrContainer className="hdr_Container">
      <S.HdrDetailContainer className="hdr_Detail_Container">
        <S.ExclOfferImg src={image} className="exclOfferImg"></S.ExclOfferImg>
        <div className="">
          <S.HdrBannerInfo className="hdr_bannerInfo">
            <S.HdrBannerTxt className="hdr_banner_Txt">
              {heading?.primaryText} <span className="latoBlack">{heading?.secondaryText}</span>
            </S.HdrBannerTxt>
            <S.SubText dangerouslySetInnerHTML={{__html: subText}} />
          </S.HdrBannerInfo>
          {imgTxt ? (
            <S.OfferImgPersuasion className="OfferImgPersuasion">
              <S.ImgTxt className="imgTxt" dangerouslySetInnerHTML={{__html: imgTxt}} />
              <S.ImgSubTxt className="imgSubTxt">{imgSubTxt}</S.ImgSubTxt>
            </S.OfferImgPersuasion>
          ) : null}
          {subHeadingImage ? (
            <S.SubHeadingOfferImg
              src={subHeadingImage}
              className="exclOfferImg"
            ></S.SubHeadingOfferImg>
          ) : null}
        </div>
      </S.HdrDetailContainer>
    </S.HdrContainer>
  );
};

export default MypHeaderContainer;
